import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-tourism-events-list',
	templateUrl: './tourism-events-list.component.html',
	styleUrls: ['./tourism-events-list.component.css'],
})
export class TourismEventsListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 9;
	protected apiUrl = 'tourismEvents';
	data: Array<object>;
	pageSizeOptions: number[] = [50, 100, 200];
	parameters = {
		vehicles: [],
		category: [],
		statuses: [],
		yesno: [],
		vehicle_type: [],
		vehicle_busType: [],
		vehicle_category: [],
		vehicle_status: [],
		users: [],
		profile: [],
		organization: [],
	};
	filters;
	tableRows: any[] = [
		{ col: 'newId', header: 'Id', size: '80' },
		{ col: 'name', header: 'Nazwa', size: '390' },
		{ col: 'date_from', header: 'Data rozpoczęcia', size: '80' },
		{ col: 'date_to', header: 'Data zakończenia', size: '80' },
		{ col: 'category', header: 'Typ wydarzenia', size: '120' },
		{ col: 'status', header: 'Status', size: '100' },
		{ col: 'date_deadline', header: 'Data Opcji', size: '80' },
		{ col: 'ownerName', header: 'Opiekun', size: '140' },
		{
			col: 'organizationOwnerName',
			header: 'Opiekun Organizacji',
			size: '140',
		},
		{
			col: 'clientEvent',
			header: 'Klient',
			size: '140',
		},
		{ col: 'vehicles', header: 'Pojazd', size: '120' },
		{
			col: 'text_opinion',
			header: 'Uwagi Powyjeździe',
			size: '210',
			longText: true,
		},
		{ col: 'deleted', header: 'Usunięte', size: '80' },
		{ col: 'leftToPay', header: 'Pozostało do zapłaty', size: '80' },
	];

	protected loadBefore(): void {
		this.api.get('/parameters/', (result, error) => {
			this.parameters.vehicle_type = this.api.typeParametersConvert(result.data, 1);
			this.parameters.vehicle_category = this.api.typeParametersConvert(result.data, 4);
			this.parameters.category = this.api.typeParametersConvert(result.data, 6);
			this.parameters.yesno = [
				{ id: 1, name: 'Tak' },
				{ id: 0, name: 'Nie' },
			];
			this.loadData();
		});
		this.api.get('/vehicles/', (result, error) => {
			this.parameters.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/users/?status=1', (result, error) => {
			this.parameters.users = result.data;
			this.loadData();
		});
		this.api.get('/vehicleBusTypes/', (result, error) => {
			this.parameters.vehicle_busType = result.data;
			this.loadData();
		});
		this.api.get('/vehicleStatuses/', (result, error) => {
			this.parameters.vehicle_status = result.data;
			this.loadData();
		});
		this.api.get('/tourismEventsStatuses/', (result, error) => {
			this.parameters.statuses = result.data;
			this.loadData();
		});
		this.bag.get('/organization/short_name/?limit=9999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.organization = result.results;
			this.loadData();
		});
		this.bag.get('/profile/data_full/?limit=9999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.profile = result.results;
			this.loadData();
		});
	}

	protected convertData(data): any[] {
		data.forEach((obj) => {
			const status = this.parameters.statuses.find((findObject) => findObject.id == obj.status);
			obj.status = status ? status.name : '?';

			obj.vehicles =
				this.parameters.vehicles
					.filter(({ id }) => obj.vehicles.some(({ vehicle_id }) => id === vehicle_id))
					.map(({ name }) => name)
					.join(',') || '?';

			const category = this.parameters.category.find((findObject) => findObject.id == obj.category);
			obj.category = category ? category.name : '?';
			const owner = this.parameters.users.find((findObject) => findObject.id == obj.owner[0]);
			obj.ownerName = owner ? owner.name : '?';
			const organizationOwner = this.parameters.users.find(
				(findObject) => findObject.id == obj.organizationOwner[0],
			);
			obj.organizationOwnerName = organizationOwner ? organizationOwner.name : '?';
			obj.clientEvent = this.findEventClient(obj);
		});
		return data;
	}

	protected findEventClient(obj): string {
		if (obj.clientEvent?.isOrganization === '1') {
			return this.findObject(this.parameters.organization, obj.clientEvent?.client)?.shortName;
		}
		if (obj.clientEvent?.isOrganization === '0') {
			obj.clientEvent = this.findObject(this.parameters.profile, obj.clientEvent?.client);
			return obj.clientEvent?.firstName + ' ' + obj.clientEvent?.lastName;
		}
	}

	protected findObject(arr, item): any {
		return arr?.find((objfind) => objfind.id === item);
	}

	filtersSelected(data): void {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-5);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+5);
		}
		this.loadData();
	}
}
